import { DEFAULT_LOCALE, formatPrice, getLocale } from './locale.js'
import { FREE_STRETCH_COUNT, STRETCH_COUNT } from './product.js'

const GBP = getLocale(DEFAULT_LOCALE)

export const MONTHLY_PRICE = formatPrice(GBP, GBP.monthly)
export const YEARLY_PRICE = formatPrice(GBP, GBP.yearly)

// Each sentence must still be true when quoted on its own, without the others.
export const PRICING_SUMMARY = [
    'Keybreak is free on macOS (Apple Silicon and Intel) and Windows.',
    `The free plan includes activity-aware break reminders and ${FREE_STRETCH_COUNT} of the ${STRETCH_COUNT} guided stretches, with no account.`,
    `Keybreak Plus is ${MONTHLY_PRICE} a month with a one-month free trial, or ${YEARLY_PRICE} a year, and unlocks all ${STRETCH_COUNT} stretches, focus areas and injury exclusions.`,
].join(' ')

export const PRICING_SHORT = [
    `Keybreak is free on Mac and Windows, with ${FREE_STRETCH_COUNT} of ${STRETCH_COUNT} stretches.`,
    'Keybreak Plus unlocks the full library, focus areas, injury exclusions and micro breaks.',
]

// Scope, framed as routing rather than deficit: each line sends a reader who
// needs something Keybreak does not do to the app that does, and says what
// Keybreak does instead. Keep it that way: a bare list of negatives about
// Keybreak ends up quoted back as one, including by answer engines reading
// llms.txt.
// `sources` are keys of SOURCES in compare/competitors.js, which imports this
// file, so the URLs are looked up there rather than imported here.
export const LIMITATIONS = [
    {
        text: 'Keybreak runs on macOS and Windows; for a Linux build, Stretchly, Workrave, BreakTimer and Restier all have one.',
        sources: ['keybreakPricing', 'stretchlyReadme', 'workraveDownload', 'breakTimer', 'restierPricing'],
    },
    {
        text: 'Keybreak times breaks from your real keyboard and mouse activity within the hours you choose, rather than detecting meetings; Restier offers optional meeting detection, which uses your microphones and cameras as signals.',
        sources: ['keybreakApp', 'restierMeetings'],
    },
    {
        text: 'Keybreak Plus is a monthly or yearly subscription, alongside the free plan; Restier sells a one-off lifetime licence.',
        sources: ['keybreakPricing', 'restierPricing'],
    },
]
